import { Component } from '@angular/core';

@Component({
	templateUrl: './unauthorized.component.html'
})
export class UnauthorizedComponent {}
